module.exports = __webpack_public_path__ + "static/media/icn_mainnav_dashboard_small.d5b40bab.svg";